import { sendToMap } from "./send-to-values";

export const getElementsVisibleOnMixer = graphicset => {
  let elements = 0;
  let hasBanners = false;

  graphicset.layouts.forEach(layout => {
    switch (layout.sendTo) {
      case sendToMap.program:
      case sendToMap.mixer:
        elements++;
        break;
      case sendToMap.banner:
        hasBanners = true;
        break;
    }
  });

  return hasBanners ? elements + 1 : elements;
};
